import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { makeApiCall } from '../common/common-action';
import { storeTransactionIdAction } from '../nium-forex/nium-forex-action';
import {
  AWAITING_PAYMENT,
  INITIATED,
  PROCESSING,
  VERIFIED,
  V_KYC_STATUS_PENDING
} from '../../../utils/constants';

//get the transaction list for respective user
export function getTransactionHistory(
  limit,
  offset,
  from_date,
  to_date,
  transaction_number,
  status_code,
  batch_number
) {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      rootReducer: {
        userStatusReducer: { account_type }
      }
    } = state;
    try {
      let response = await makeApiCall({
        url: `${API_URL}/transaction/transaction-history`,
        method: 'get',
        withCredentials: true,
        params: {
          limit,
          offset,
          from_date,
          to_date,
          transaction_number,
          status_code,
          account_type
        }
      });
      if (response?.data?.success && response?.data?.data) {
        return { data: response.data.data.data, totalCount: response.data.data.total_count };
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export function cancelTransactionByTransactionId(transactionId, data, isNiumForexUser) {
  const requestUrl = `${API_URL}${
    isNiumForexUser ? '/niumForex' : ''
  }/transaction/${transactionId}/cancel`;
  return async (dispatch) => {
    try {
      return await makeApiCall({
        url: requestUrl,
        method: isNiumForexUser ? 'patch' : 'post',
        withCredentials: true,
        data: data
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getCancellationReason(isNiumForexUser) {
  const requestUrl = isNiumForexUser
    ? 'niumForex/instarem-object/dropdown?type=REASON_FOR_CANCELLATION&account_type=INDIVIDUAL'
    : 'instarem-objects/dropdown?type=REASON_FOR_CANCELLATION&value=name';
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/${requestUrl}`,
        method: 'get',
        withCredentials: true
      });
      if (response && response.data && response.data.success && response.data.data) {
        return response.data.data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export function isTransactionCancellable(transactionNo) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/transaction/${transactionNo}/is-transaction-cancellable`,
        method: 'get',
        withCredentials: true
      });
      if (response && response.data && response.data.success && response.data.data) {
        return response.data.data.is_cancellable;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return false;
  };
}

export function addReferenceNo(BankRefNo, transactionId) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        url: `${API_URL}/transaction/reference`,
        method: 'post',
        withCredentials: true,
        data: {
          bank_reference_number: BankRefNo,
          transaction_id: transactionId
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getTransactionTimelineData(transactionId) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/transactions/${transactionId}/timeline`,
        method: 'get',
        withCredentials: true
      });
      return response?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getNiumForexTransactionHistory(
  limit,
  offset,
  from_date,
  to_date,
  transaction_number,
  isSendMoneyPage = false,
  status_code
) {
  return async (dispatch, getState) => {
    let isNewTransactionRestricted = false;
    try {
      let response = await makeApiCall({
        url: `${API_URL}/niumForex/transaction/history`,
        method: 'get',
        withCredentials: true,
        params: {
          limit,
          offset,
          from_date,
          to_date,
          transaction_number,
          status_code
        }
      });
      if (response?.data?.success) {
        if (isSendMoneyPage) {
          const state = getState();
          const {
            rootReducer: {
              niumForexReducer: {
                userDetails: {
                  pan_status: panStatus,
                  aadhar_status: aadharStatus,
                  video_kyc_status: vKYCStatus
                }
              }
            }
          } = state;
          const newTransactionRestrictedCondition =
            panStatus === VERIFIED &&
            aadharStatus === VERIFIED &&
            (vKYCStatus === V_KYC_STATUS_PENDING || vKYCStatus === INITIATED);
          const { data: transactionList } = response?.data || '';
          const awaitingTransactionDataList =
            transactionList?.filter(
              (transaction) =>
                transaction?.status_code === AWAITING_PAYMENT ||
                transaction.status_code === PROCESSING
            ) || [];
          if (newTransactionRestrictedCondition && awaitingTransactionDataList?.length > 0) {
            dispatch(storeTransactionIdAction(awaitingTransactionDataList[0].transaction_id));
            isNewTransactionRestricted = true;
          }
          return {
            isNewTransactionRestricted,
            data: response.data.data,
            totalCount: response.data.total_count
          };
        }
        return { data: response.data.data, totalCount: response.data.total_count };
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    if (isSendMoneyPage) return { data: [], isNewTransactionRestricted };
    else return [];
  };
}
